import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import RecipesHome from './components/RecipesHome/RecipesHome';
import RecipeHome from './components/Recipe/RecipeHome';
import RecipeIngredients from './components/Recipe/RecipeIngredients/RecipeIngredients';
import RecipeSteps from './components/Recipe/RecipeSteps/RecipeSteps';
import RecipeTips from './components/Recipe/RecipeTips/RecipeTips';
import RecipeTools from './components/Recipe/RecipeTools/RecipeTools';
import RecipeAmount from './components/Recipe/RecipeAmount/RecipeAmount';
import Paywall from './components/Paywall/Paywall';

function App() {
  const location = useLocation();

  return (
    <AnimatePresence exitBeforeEnter>
      <Routes location={location} key={location.pathname}>
        <Route index element={<Navigate to="recipes" replace />} />
        <Route path="recipes" element={<RecipesHome />} />
        <Route path="paywall" element={<Paywall />} />
        <Route path="recipe/:slug" element={<RecipeHome />} />
        <Route
          path="recipe/:slug/ingredients"
          element={<RecipeIngredients />}
        />
        <Route path="recipe/:slug/tools" element={<RecipeTools />} />
        <Route path="recipe/:slug/tips" element={<RecipeTips />} />
        <Route path="recipe/:slug/amount" element={<RecipeAmount />} />
        <Route path="recipe/:slug/steps" element={<RecipeSteps />} />
      </Routes>
    </AnimatePresence>
  );
}

export default App;
